import SkeletonBone from './SkeletonBone';

export default function RiskCardSkeleton() {
  return (
    <article
      aria-hidden="true"
      className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950/60 p-4 shadow-lg shadow-slate-200/70 dark:shadow-slate-950/20"
    >
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-2">
          <div className="flex items-center gap-2">
            <SkeletonBone className="h-3 w-14" rounded="rounded-full" />
            <SkeletonBone className="h-5 w-12" rounded="rounded-full" />
          </div>
          <SkeletonBone className="h-6 w-3/5 max-w-[12rem]" />
          <SkeletonBone className="h-4 w-2/5 max-w-[9rem]" />
        </div>
        <div className="shrink-0 space-y-2 text-right">
          <SkeletonBone className="ml-auto h-7 w-12" rounded="rounded-full" />
          <SkeletonBone className="ml-auto h-3 w-16" />
        </div>
      </div>

      <SkeletonBone className="mb-3 h-2 w-full" rounded="rounded-full" />

      <div className="space-y-2.5">
        <SkeletonBone className="h-4 w-[92%]" />
        <SkeletonBone className="h-4 w-[78%]" />
        <SkeletonBone className="h-4 w-[84%]" />
        <SkeletonBone className="h-4 w-[70%]" />
        <SkeletonBone className="h-4 w-[88%]" />
        <SkeletonBone className="h-4 w-[62%]" />
        <SkeletonBone className="h-4 w-[56%]" />
      </div>

      <div className="mt-4 flex flex-wrap gap-1.5">
        <SkeletonBone className="h-6 w-20" rounded="rounded-full" />
        <SkeletonBone className="h-6 w-24" rounded="rounded-full" />
        <SkeletonBone className="h-6 w-16" rounded="rounded-full" />
      </div>
    </article>
  );
}
